<script setup lang="ts">
import ComponentRender from "./ComponentRender.vue";
import {
  setProxy,
  PageProxy,
  removePageProxy,
  type ShowFormParameters,
} from "@/global";
import { onUnmounted, provide, reactive } from "vue";

const props = defineProps<{ showParams: ShowFormParameters }>();
const proxy = reactive(new PageProxy(props.showParams));
proxy.init();
setProxy(props.showParams.pageId, "$Form", proxy);

provide("showParams", props.showParams);

onUnmounted(() => {
  proxy.close(props.showParams.pageId);
  removePageProxy(props.showParams.pageId);
});
</script>
<template>
  <div class="form">
    <ComponentRender
      v-for="component in showParams.metadata.components"
      :key="component.uid"
      class="component"
      :component="component"
    />
    <nut-popup
      v-for="popup in proxy.popups"
      pop-class="popup-form"
      :key="popup.pageId"
      :visible="true"
      close-icon-position="top-left"
      :close-on-click-overlay="false"
      :position="popup.position"
      :round="popup.round"
      :style="{ background: popup.background }"
    >
      <PageRender :show-params="popup" />
    </nut-popup>
  </div>
</template>
<style lang="scss">
.form {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.component {
  flex-shrink: 0 !important;
}

.popup-form {
  height: 85vh;
}
</style>
